import React, { Component } from 'react'
//import { Link } from 'react-router-dom'
import Moment from 'moment';
import { getfmpData } from '../lib/stockServices'
import { calculateBuyRange } from '../helpers/utils'
import NumberFormat from 'react-number-format'

class Row extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentPrice: '-',
      companyName: '-'
    }
  }

  handleClick = () => {
    this.props.remove(this.props.id)
  }

  componentWillMount = () => {
    getfmpData(this.props.symbol)
    .then(data => {
      this.setState({
        currentPrice: data.price,
      })
    })
  }

  recommendationClass = (recommendation) => {
    switch (recommendation.name) {
      case 'Sell':
        return 'red pa3 tl b'
      case 'Watch':
        return 'gold pa3 tl b'
      case 'Buy':
        return 'green pa3 tl b'
      default:
        return 'pa3 tl b'
    }
  }

  render() {
    const { currentPrice } = this.state;

    const {
      lowBuyRange,
      highBuyRange,
      frozenPrice,
      practicalValuation,
      theoreticalValuation,
      practicalReturn,
      //theoreticalReturn,
      date,
      opsType,
      marketGrowth,
      theoreticalGrowth,
      userGrowth,
      futurePE,
      futurePM,
      shrTrend,
      profitMargin,
      dividend,
      costofEquity,
      sales,
      shares,
      PE,
      pmGrowth,
      earningsGrowth,
      analystsGrowth,
      futureR,
      futureCoE,
      futureEarningsGrowth,
      futureRf,

    } = this.props.data

    const recommendation = calculateBuyRange(currentPrice,frozenPrice, lowBuyRange, highBuyRange,date,practicalReturn, theoreticalValuation,practicalValuation)
    const recommendationClass = this.recommendationClass(recommendation)

    return(
      <tr className="bt b--light-gray bg-animate bg-white hover-bg-near-white hide-child">
        <td className="pa3 tl">
        <span classname="f1 fw4 f5 w3">{this.props.symbol} </span>
        </td>
        <td className="pa3 tl dn dtc-l">
          <span className="fl fw4 f5 w3">{opsType === 0 ? "Stable" : opsType === 1 ? "Dynamic" : "" }</span>
        </td>
        <td className="pa3 tl dn dtc-l">
          <span className="fl fw4 f5 w3">{Moment(date).format('M/D/YY')}</span>
        </td>
        <td className="pa3 tl">
          <NumberFormat value={practicalReturn} displayType={"text"} decimalPrecision={1} suffix={'%'}/>
        </td>
        <td className="pa3 tl">
          <NumberFormat value={frozenPrice} displayType={"text"} decimalPrecision={2} prefix={'$'}/>
        </td>
        <td className="pa3 tl">
          <NumberFormat value={currentPrice} displayType={"text"} decimalPrecision={2} prefix={'$'}/>
        </td>
        <td className={recommendationClass}>
          {recommendation.name ? recommendation.name : ''}
        </td>
        <td className="pa3 tl">
          &lt;= <NumberFormat value={recommendation.transitionPrice1 - .01} displayType={"text"} decimalPrecision={2} prefix={'$'} suffix={' '}/>
        </td>
        <td className="pa3 tl">
         <NumberFormat value={recommendation.transitionPrice1} displayType={"text"} decimalPrecision={2} prefix={'$'}/>
         --<NumberFormat value={recommendation.transitionPrice2 - .01} displayType={"text"} decimalPrecision={2} prefix={'$'}/>
        </td>
        <td className="pa3 tl">
         <NumberFormat value={recommendation.transitionPrice2} displayType={"text"} decimalPrecision={2} prefix={'$'}/>
         --<NumberFormat value={recommendation.transitionPrice4} displayType={"text"} decimalPrecision={2} prefix={'$'}/>
        </td>
        <td className="pa3 tl">
         <NumberFormat value={recommendation.transitionPrice4 + .01} displayType={"text"} decimalPrecision={2} prefix={'$'}/>
         --<NumberFormat value={recommendation.transitionPrice6 - .01} displayType={"text"} decimalPrecision={2} prefix={'$'}/>
        </td>
        <td className="pa3 tl">
         <NumberFormat value={recommendation.transitionPrice6} displayType={"text"} decimalPrecision={2} prefix={'$'}/>
         --<NumberFormat value={recommendation.transitionPrice7 - .01} displayType={"text"} decimalPrecision={2} prefix={'$'}/>
        </td>
        <td className="pa3 tl">
         &gt;= <NumberFormat value={recommendation.transitionPrice7} displayType={"text"} decimalPrecision={2} prefix={'$'} suffix={' '}/>
        </td>
        <td>
          <NumberFormat value={theoreticalValuation} displayType={"text"} decimalPrecision={2} prefix={'$'}/>
        </td>
        <td>
          <NumberFormat value={practicalValuation} displayType={"text"} decimalPrecision={2} prefix={'$'}/>
        </td>
        <td>
          <NumberFormat value= {marketGrowth * 100} displayType={"text"} decimalPrecision={1} suffix={'%'}/>
        </td>
        <td>
          <NumberFormat value= {theoreticalGrowth * 100} displayType={"text"} decimalPrecision={1} suffix={'%'}/>
        </td>
        <td>
          <NumberFormat value={userGrowth * 100} displayType={"text"} decimalPrecision={1} suffix={'%'}/>
        </td>
        <td>
          <NumberFormat value={shrTrend*100} displayType={"text"} decimalPrecision={1} suffix={'%'}/>
        </td>
        <td>
          <NumberFormat value={futurePM*100} displayType={"text"} decimalPrecision={1} suffix={'%'}/>
        </td>
        <td>
          <NumberFormat value={futurePE} displayType={"text"} decimalPrecision={1} />
        </td>
        <td>
          <NumberFormat value={sales} displayType={"text"} decimalPrecision={1}/>
        </td>
        <td>
          <NumberFormat value={shares} displayType={"text"} decimalPrecision={1}/>
        </td>
        <td>
          <NumberFormat value={profitMargin * 100} displayType={"text"} decimalPrecision={1} suffix={'%'}/>
        </td>
        <td>
          <NumberFormat value={PE} displayType={"text"} decimalPrecision={1}/>
        </td>
        <td>
          <NumberFormat value={dividend * 100} displayType={"text"} decimalPrecision={2} suffix={'%'}/>
        </td>
        <td>
          <NumberFormat value={costofEquity * 100} displayType={"text"} decimalPrecision={1} suffix={'%'}/>
        </td>
        <td>
          <NumberFormat value={pmGrowth * 100} displayType={"text"} decimalPrecision={1} suffix={'%'}/>
        </td>
        <td>
          <NumberFormat value={earningsGrowth * 100} displayType={"text"} decimalPrecision={1} suffix={'%'}/>
        </td>
        <td>
          <NumberFormat value={analystsGrowth * 100} displayType={"text"} decimalPrecision={1} suffix={'%'}/>
        </td>
        <td>
          <NumberFormat value={futureR * 100} displayType={"text"} decimalPrecision={1} suffix={'%'}/>
        </td>
        <td>
          <NumberFormat value={futureCoE * 100} displayType={"text"} decimalPrecision={1} suffix={'%'}/>
        </td>
        <td>
          <NumberFormat value={futureEarningsGrowth * 100} displayType={"text"} decimalPrecision={1} suffix={'%'}/>
        </td>
        <td>
          <NumberFormat value={futureRf * 100} displayType={"text"} decimalPrecision={1} suffix={'%'}/>
        </td>
        <td className="pa3 tl child pointer">
          <i className="material-icons silver fr" onClick={this.handleClick}>close</i>
        </td>
      </tr>
    )
  }
}

export default Row



// WEBPACK FOOTER //
// ./src/components/Row.js